import {authRoles} from 'auth';
import store from 'store';
import {logoutUser} from 'auth/store/actions';

export const LogoutConfig = {
    auth  : authRoles.any,
    routes: [
        {
            path     : '/logout',
            component: () => {
                store.dispatch(logoutUser());
                return 'Logging out..'
            }
        }
    ]
};

